export { default } from "./Ventas";
